import { Component } from '@angular/core';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './not-found.component.html'
})
export class PageNotFoundComponent {}
